class ProductSelector extends HTMLElement {
  constructor() {
    super();
    this.inputWrapper = '[data-input-wrapper]';
    this.variants = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );
    this.form = document.querySelector(
      `#ProductForm-${this.dataset.sectionId}`
    );
    this.purchaseOptions = document.querySelector(
      `#Product-Purchase-Options-${this.dataset.sectionId}`
    );
    this.productBar = document.querySelector(
      `#ProductBar-${this.dataset.sectionId}`
    );
    this.installmentsForm = document.querySelector(
      `#Product-Installments-${this.dataset.installmentsFormId}`
    );

    this.addEventListener('change', this.onVariantChange.bind(this));

    this.updateOptions();
    this.updateVariantStatuses();
    this.updateVariant();
    this.initUpdateMedia();

    if (this.form) {
      this.form.toggleAddButton(!this.currentVariant.available, '');
    }
  }

  updateOptions() {
    const fieldsets = this.querySelectorAll('fieldset');
    this.options = Array.from(fieldsets).map(fieldset => {
      const legend = fieldset.querySelector('legend');
      const checkedInput = fieldset.querySelector('input:checked');
      return {
        name: legend.textContent.trim(),
        value: checkedInput ? checkedInput.value : null
      };
    });
  }

  getVariantData() {
    return this.variants.find(variant => {
      return this.options.every((option, index) => {
        return variant[`option${index + 1}`] === option.value;
      });
    });
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateVariantStatuses();
    
    const previousVariant = this.currentVariant;
    this.updateVariant();

    if (this.currentVariant === previousVariant) return;

    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateVariantStatuses() {
    const inputWrappers = [...this.querySelectorAll(this.inputWrapper)];

    inputWrappers.forEach((wrapper, wrapperIndex) => {
      const inputElements = wrapper.querySelectorAll('input[type="radio"]');
      
      inputElements.forEach(input => {
        const inputValue = input.getAttribute('value');
        const availableVariant = this.variants.find(variant => {
          return this.options.every((option, optionIndex) => {
            if (optionIndex === wrapperIndex) {
              return variant[`option${optionIndex + 1}`] === inputValue;
            }
            return variant[`option${optionIndex + 1}`] === option.value;
          });
        });

        const label = wrapper.querySelector(`label[for="${input.id}"]`);
        if (label) {
          if (availableVariant && availableVariant.available) {
            label.classList.remove('attr-disabled');
          } else {
            label.classList.add('attr-disabled');
          }
        }
      });
    });
  }

  onVariantChange(event) {
    if (event.target.type === 'number') return;
    this.updateOptions();
    if (this.currentVariant === this.getVariantData()) return;

    this.updateVariant();
    this.updateVariantStatuses();
    this.productBarUpdateOptions();
    this.updatePickupAvailability();
    if (this.form) {
      this.form.removeAttribute('data-has-selling-plan');
      this.form.toggleAddButton(false, '');
      this.form.handleErrorMessage();
    }

    if (!this.currentVariant) {
      if (this.form) {
        this.form.toggleAddButton(true, '');
      }
      this.setUnavailable();

      return;
    }

    if (!this.currentVariant.available) {
      if (this.form) {
        this.form.toggleAddButton(true, window.variantStrings.soldOut);
      }
    }

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.querySelectorAll('input[type="radio"]').forEach(input => {
      input.nextElementSibling.classList.toggle(
        'is-active',
        input.checked
      );
    });
    this.options = Array.from(
      this.querySelectorAll('input[type="radio"]:checked, select'),
      el => ({ name: el.dataset.name || el.name, value: el.value })
    );
  }

  productBarUpdateOptions() {
    if (this.productBar) {
      Array.from(this.productBar.querySelectorAll('select')).map(
        selector => {
          selector.value = this.options.find(
            option => option.name === selector.name
          ).value;
        }
      );
      this.productBar.querySelectorAll('dropdown-input').forEach(
        dropdown => {
          dropdown.update();
        }
      );
    }
  }

  updateInventoryNotice(html) {
    const destinationBlocks = document.querySelectorAll('[data-inventory-notice-block]');
    const sourceBlocks = html.querySelectorAll('[data-inventory-notice-block]');
    
    destinationBlocks.forEach((destBlock, index) => {
        const sourceBlock = sourceBlocks[index];
        if (!sourceBlock) return;
        
        const showInventory = destBlock.dataset.showInventory === 'true';
        if (!showInventory) return;
        
        // Get elements
        const destIcon = destBlock.querySelector('[data-inventory-icon]');
        const destNoticeText = destBlock.querySelector('[data-inventory-notice-text]');
        const destStaticContent = destBlock.querySelector('[data-static-content]');
        const sourceIcon = sourceBlock.querySelector('[data-inventory-icon]');
        const sourceNoticeText = sourceBlock.querySelector('[data-inventory-notice-text]');
        
        // Update notice text
        if (destNoticeText && sourceNoticeText) {
            destNoticeText.innerHTML = sourceNoticeText.innerHTML;
        }
        
        // Update icon by cloning from source
        if (destIcon && sourceIcon) {
            // Clear current icon
            destIcon.innerHTML = '';
            
            // Clone the icon content from source
            const iconContent = sourceIcon.innerHTML;
            if (iconContent) {
                destIcon.innerHTML = iconContent;
            }
            
            // Update data attribute for icon state
            destIcon.dataset.iconState = sourceIcon.dataset.iconState;
        }
        
        // Show/hide static content based on stock status
        if (destStaticContent && sourceIcon) {
            const isOutOfStock = sourceIcon.dataset.iconState === 'out-of-stock';
            
            if (isOutOfStock) {
                // Hide all static content when out of stock
                destStaticContent.style.display = 'none';
            } else {
                // Show static content when in stock
                destStaticContent.style.display = 'inline';
            }
        }
        
        // Extract inventory quantity for quantity input (only from first block)
        if (index === 0) {
            const inventoryQuantityMatch = sourceNoticeText?.textContent.match(/\d+/);
            const inventoryQuantity = inventoryQuantityMatch ? parseInt(inventoryQuantityMatch[0]) : 0;
            this.updateQuantityInput(inventoryQuantity);
        }
    });
}

  updateQuantityInput(inventoryQuantity) {
    const selectedVariantData = this.getVariantData();
    const quantityInput = document.querySelector('.product-selector__quantity quantity-input input');

    let productUsesInventory = true;

    // check inventory is active
    if (selectedVariantData && selectedVariantData.inventory_management === null) {
      productUsesInventory = false;
    }

    // check sell on sold out is active
    if (selectedVariantData && selectedVariantData.inventory_quantity !== null && inventoryQuantity === 0 && selectedVariantData.available === true) {
      productUsesInventory = false;
    }

    if (quantityInput) {
      if (productUsesInventory) {
        quantityInput.setAttribute('max', inventoryQuantity);
        quantityInput.value = 1;
        // set value accordingly to inventory
        if (quantityInput.value > inventoryQuantity) {
          quantityInput.value = inventoryQuantity;
        }
      } else {
        quantityInput.setAttribute('max', '');
      }
    }
  }

  updatePickupAvailability() {
    const pickUpAvailabilityNode = document.querySelector(
      'pickup-availability'
    );

    if (!pickUpAvailabilityNode || !this.currentVariant) return;

    pickUpAvailabilityNode.dataset.variantId = this.currentVariant.id;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailabilityNode.setAttribute('available', '');
      pickUpAvailabilityNode.fetchAvailability(
        pickUpAvailabilityNode.dataset.variantId
      );

      return;
    }

    pickUpAvailabilityNode.removeAttribute('available');
    pickUpAvailabilityNode.innerHTML = '';
  }

  updateVariant() {
    this.currentVariant = this.getVariantData();
  }

  getVariantData() {
    if (this.options.length === 0) {
      return this.variants[0]; // Return the first variant if no options are selected
    }

    return this.variants.find(variant => {
      // Check if the variant's options match the selected options
      return this.options.every(option => {
        const optionIndex = this.options.findIndex(opt => opt.name === option.name) + 1;
        return variant[`option${optionIndex}`] === option.value;
      });
    });
  }

  initUpdateMedia() {

    const urlParams = new URLSearchParams(window.location.search);
    const variantIdFromUrl = parseInt(urlParams.get('variant'));

    if (variantIdFromUrl) {
      this.currentVariant = this.variants.find(variant => variant.id === variantIdFromUrl);

      if (this.currentVariant) {
        this.updateMedia();
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media)
      return;

    const productMedia = document.querySelector('product-media');
    productMedia.setActiveMedia(
      this.currentVariant.featured_media.id
    );
  }

  updateURL(sellingPlanId) {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id
    );
    if (sellingPlanId) {
      params[params.has('selling_plan') ? 'set' : 'append'](
        'selling_plan',
        sellingPlanId
      );
    } else {
      params.delete('selling_plan');
    }
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`
    );
  }

  updateVariantInput() {
    const inputs = [
      this.querySelector('[name="id"]'),
      this.installmentsForm?.querySelector('[name="id"]')
    ];
    inputs.forEach(input => {
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  setUnavailable() {
    const submitButton = this.form.submitButton;
    const price = this.querySelector(
      `#Product-Price-${this.dataset.sectionId}`
    );

    if (!submitButton) return;
    submitButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  renderProductInfo() {
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id
    );
    params.append('section_id', this.dataset.sectionId);

    fetch(`${this.dataset.url}?${params.toString()}`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(
          responseText,
          'text/html'
        );
        [
          `#Product-Price-${this.dataset.sectionId}`,
          `#Product-Purchase-Options-${this.dataset.sectionId}`
        ].map(liveRegionSelector => {
          const destination = document.querySelector(
            liveRegionSelector
          );
          const source = html.querySelector(liveRegionSelector);

          this.updateInventoryNotice(html);

          if (destination && source) {
            destination.classList.remove('visibility-hidden');
            destination.innerHTML = source.innerHTML;
          }
        });
      });
  }
}

customElements.define('product-selector', ProductSelector);
